<div class="case-title-header">
  <div class="case-page-title">
    @if(iconClass) {
      <i [class]="iconClass" (click)="goTo()" [ngClass]="{'icon-link': iconLink}"></i>
    }
      {{ title }}
    @if(description) {
      - {{ description }} 
    }
    @if(viewMode && title) {
      <i class="bi bi-copy copy-title" (click)="copyToClipboard()"></i>
      <span class="copy-message">{{ copiedMessage | translate }}</span>
    }
  </div>
  <div class="actions">
    <ng-content></ng-content>
  </div>
</div>
